"client export"
import t from "prop-types";
import e from "react";
import { resolve as n, Location as r, Link as o } from "@gatsbyjs/reach-router";
import { applyTrailingSlashOption as s } from "gatsby-page-utils/apply-trailing-slash-option";

function i() {
    return i = Object.assign ? Object.assign.bind() : function (t) {
        for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];
            for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
    }, i.apply(this, arguments);
}

function a(t) {
    let e = t || "/", n = "", r = "";
    const o = e.indexOf("#");
    if (-1 !== o) {
        r = e.slice(o);
        e = e.slice(0, o);
    }
    const s = e.indexOf("?");
    if (-1 !== s) {
        n = e.slice(s);
        e = e.slice(0, s);
    }
    return { pathname: e, search: "?" === n ? "" : n, hash: "#" === r ? "" : r };
}

const c = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/;
const l = t => "string" == typeof t && !c.test(t);
const p = () => "production" !== process.env.NODE_ENV ? "undefined" != typeof __PATH_PREFIX__ ? __PATH_PREFIX__ : void 0 : __PATH_PREFIX__;

function h(t, e = (() => "production" !== process.env.NODE_ENV ? "undefined" != typeof __BASE_PATH__ ? __BASE_PATH__ : void 0 : __BASE_PATH__)()) {
    var n;
    if (!l(t)) return t;
    if (t.startsWith("./") || t.startsWith("../")) return t;
    const r = null != (n = null != e ? e : p()) ? n : "/";
    return `${r.endsWith("/") ? r.slice(0, -1) : r}${t.startsWith("/") ? t : `/${t}`}`;
}

const f = t => null == t ? void 0 : t.startsWith("/");
const u = () => "undefined" != typeof __TRAILING_SLASH__ ? __TRAILING_SLASH__ : void 0;

const _ = (t, e) => "number" == typeof t ? t : l(t) ? f(t) ? function (t) {
    const e = h(t), n = u();
    if ("always" === n || "never" === n) {
        const { pathname: t, search: r, hash: o } = a(e);
        return `${s(t, n)}${r}${o}`;
    }
    return e;
}(t) : function (t, e) {
    if (f(t)) return t;
    const r = u(), o = n(t, e);
		const { pathname, search, hash } = a(o);
    return "always" === r || "never" === r ? `${s(pathname, r)}${search}${hash}` : o;
}(t, e) : t;

const d = ["to", "getProps", "onClick", "onMouseEnter", "activeClassName", "activeStyle", "innerRef", "partiallyActive", "state", "replace", "_location"];

function m(t) {
    return h(t, p());
}

const y = {
    activeClassName: t.string,
    activeStyle: t.object,
    partiallyActive: t.bool
};

function v(t) {
    return e.createElement(r, null, ({ location: n }) => e.createElement(b, i({}, t, { _location: n })));
}

class b extends e.Component {
    constructor(t) {
        super(t);
        this.defaultGetProps = ({ isPartiallyCurrent: t, isCurrent: e }) =>
            (this.props.partiallyActive ? t : e) ? {
                className: [this.props.className, this.props.activeClassName].filter(Boolean).join(" "),
                style: i({}, this.props.style, this.props.activeStyle)
            } : null;
        let e = !1;
        "undefined" != typeof window && window.IntersectionObserver && (e = !0);
        this.state = { IOSupported: e };
        this.abortPrefetch = null;
        this.handleRef = this.handleRef.bind(this);
    }

    _prefetch() {
        let t = window.location.pathname + window.location.search;
        if (this.props._location && this.props._location.pathname) {
            t = this.props._location.pathname + this.props._location.search;
        }
        const e = a(_(this.props.to, t)), n = e.pathname + e.search;
        if (t !== n) return ___loader.enqueue(n);
    }

    componentWillUnmount() {
        if (!this.io) return;
        const { instance: t, el: e } = this.io;
        this.abortPrefetch && this.abortPrefetch.abort();
        t.unobserve(e);
        t.disconnect();
    }

    handleRef(t) {
        this.props.innerRef && Object.prototype.hasOwnProperty.call(this.props.innerRef, "current")
            ? (this.props.innerRef.current = t)
            : this.props.innerRef && this.props.innerRef(t);
        if (this.state.IOSupported && t) {
            this.io = ((t, e) => {
                const n = new window.IntersectionObserver(n => {
                    n.forEach(n => {
                        t === n.target && e(n.isIntersecting || n.intersectionRatio > 0);
                    });
                });
                n.observe(t);
                return { instance: n, el: t };
            })(t, t => {
                t ? (this.abortPrefetch = this._prefetch()) : this.abortPrefetch && this.abortPrefetch.abort();
            });
        }
    }

    render() {
        const t = this.props,
            { to: n, getProps: r = this.defaultGetProps, onClick: s, onMouseEnter: c, state: p, replace: h, _location: f } = t,
            u = ((t, e) => {
                if (null == t) return {};
                var n, r, o = {}, s = Object.keys(t);
                for (r = 0; r < s.length; r++) e.indexOf(n = s[r]) >= 0 || (o[n] = t[n]);
                return o;
            })(t, d);

        const m = _(n, f.pathname);
        return l(m)
            ? e.createElement(o, i({ to: m, state: p, getProps: r, innerRef: this.handleRef, onMouseEnter: t => { c && c(t); const e = a(m); ___loader.hovering(e.pathname + e.search); }, onClick: t => { if (s && s(t), !(t.button || this.props.target || t.defaultPrevented || t.metaKey || t.altKey || t.ctrlKey || t.shiftKey)) { t.preventDefault(); window.___navigate(m, { state: p, replace: h }); } return !0; } }, u))
            : e.createElement("a", i({ href: m }, u));
    }
}

b.propTypes = i({}, y, { onClick: t.func, to: t.string.isRequired, replace: t.bool, state: t.object });
export default e.forwardRef((t, n) => e.createElement(v, i({ innerRef: n }, t)));
export const P = (t, e) => { window.___navigate(_(t, window.location.pathname), e); };
export { a as parsePath, m as withAssetPrefix, h as withPrefix };
